import { SquaresFourIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Table = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <SquaresFourIcon {...rest} size={Sizes[size]} color={fill} />;
};

Table.displayName = 'Table';
